import React from 'react';
import { BrandColor } from '@styleseat/brand';
import { Box } from '@styleseat/ui';
import {
  Absolute,
  BodyText,
  Button,
  HeaderText,
  PortalOverlay,
  PortalOverlayHeaderCloseBtn,
  PortalOverlayModal,
  Stack,
} from '../../../ui';

import { TopProIcon } from '../TopProIcon';

export type TopProPopoverProps = {
  providerName: string;
  onClose: () => void;
  onBackdropClick: () => void;
};

export enum PaymentSelectChoice {
  PayNow = 'pay-now',
  AutoPay = 'auto-pay',
}

export const TopProPopover = ({
  providerName,
  onBackdropClick,
  onClose,
}: TopProPopoverProps) => (
  <PortalOverlay
    name="top-pro-popover"
    onBackdropClick={onBackdropClick}
    animationStyle="slideUp"
  >
    <PortalOverlayModal
      position="menu"
      borderRadiusTop={8}
      testID="profile-TopProPopover__modal"
    >
      <Box
        flexGrow={1}
        alignItems="center"
        justifyContent="center"
        paddingTop={8}
      >
        <Stack padding={16} space={4}>
          <Box testID="top-pro-icon" alignItems="flex-start">
            <TopProIcon width={48} height={48} active />
          </Box>
          <HeaderText
            level={1}
            testID="top-pro-popover-heading"
            weight="bold"
          >
            {providerName} is a Top Pro
          </HeaderText>
          <BodyText color={BrandColor.Metal}>
            Top Pros have an outstanding track record for
            delivering exceptional client experiences.
          </BodyText>
          <Box padding={16}>
            <Button
              onClick={onClose}
              appearance="link-lowercase"
              testID="profile-TopProPopover__close"
            >
              Close
            </Button>
          </Box>
        </Stack>
      </Box>
      <Absolute right={16} top={24}>
        <PortalOverlayHeaderCloseBtn onCloseRequest={onClose} />
      </Absolute>
    </PortalOverlayModal>
  </PortalOverlay>
);
